export default "__VITE_ASSET__Cxfch5FA__"